import { DURATION_ALWAYS } from '../constants'
import { formatISO8601Duration } from './format-iso-8601-duration'

/**
 * Format a duration also considering the "unlimited" period.
 *
 * @param {Intl} intl   - The modux intl helper.
 * @param {string} duration - The period e.g. a ISO duration string
 * @return {string|*}
 */
export function formatDuration(intl, duration) {
    if (duration === DURATION_ALWAYS) {
        return intl.translate('atl_no_limit')
    }
    return formatISO8601Duration(intl, duration)
}
